import { GenericVariable, Variable } from "~/types/Variable";

const genericTypes = new Set<Variable["type"]>(["array", "map"]);

export const isGeneric = (variable: Variable): variable is GenericVariable => {
  return genericTypes.has(variable.type);
};
